import { NgOptimizedImage, NgIf, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { getRouterSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { NavItems } from 'src/app/core/interfaces/interfaces';
import { UrlSanitizerPipe } from 'src/app/core/pipes/urlSanitizer/url-sanitizer.pipe';
import { GameLaunchService } from 'src/app/core/services/gameLaunch/game-launch.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { FilterActions } from 'src/app/core/store/filters/actions/filter.actions';

@Component({
  selector: 'app-sidebar-category-link',
  templateUrl: './sidebar-category-link.component.html',
  styleUrls: ['./sidebar-category-link.component.scss'],
  standalone: true,
  imports: [TranslocoModule, NgOptimizedImage, NgIf, NgFor, UrlSanitizerPipe],
})
export class SidebarCategoryLinkComponent implements OnDestroy {
  @Output()
  linkClick: EventEmitter<any> = new EventEmitter<any>();
  categoryLinks: Array<NavItems> = [
    {
      name: 'buttons.All Games',
      url: '/games/all',
      variant: 'primary',
      svg: 'https://cdn.chipychapa.com//welle/General_site/Sidebar/all_games.svg',
      isActive: false,
    },
    {
      name: 'buttons.Live Casino',
      url: '/games/livecasino',
      variant: 'primary',
      svg: 'https://cdn.chipychapa.com//welle/General_site/Sidebar/live_slots.svg',
      isActive: false,
    },
    {
      name: 'buttons.Sportbook',
      url: '/game/popular/0/1477472',
      variant: 'primary',
      svg: 'https://cdn.chipychapa.com//welle/General_site/Sidebar/sportbook.svg',
      isActive: false,
    },
  ];
  Router$: Observable<any> = this.store.select(getRouterSelectors().selectUrl);
  unsubus$: Subject<boolean> = new Subject();
  @Input() isSidebar: boolean = false;
  @Input() restrictUser: boolean = false;

  constructor(
    private navigator: NavigationService,
    private store: Store,
    private gameLaunch: GameLaunchService
  ) {
    this.Router$.pipe(takeUntil(this.unsubus$)).subscribe((res: any) => {
      this.categoryLinks.forEach((link) => {
        link.isActive = res?.includes(link.url) ? true : false;
      });
    });
  }

  buttonClick(url: string) {
    if (url === '') return;
    if (url.indexOf('game/') > -1) {
      const game = url.replace('/game/', '').split('/');
      this.gameLaunch.checkUserProfile(`game/${game[0]}/${game[1]}/${game[2]}`);
      this.linkClick.emit();
      return;
    }
    if (url.indexOf('games') > -1) {
      const slug = url.replace('/games/', '');
      this.store.dispatch(
        FilterActions['[SetFilter]SetFilterCategorySuccess']({
          data: slug,
        })
      );
    }
    this.navigator.navigateTo(url);
    this.linkClick.emit();
  }
  ngOnDestroy() {
    this.unsubus$.next(true);
    this.unsubus$.complete();
  }
}
